
<template>
  <div class="featuresSlider">
    <vueper-slides autoplay fade bullets-outside :slideRatio="1100/1600">
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :image="slide.image"
        :title="slide.title"
      />
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "FeaturesSlideContent",
  components: { VueperSlides, VueperSlide },
  data: function() {
    let baseUrl =
      "https://espocial.s3.eu-central-1.amazonaws.com/assets/app/welcomeslider/v2/";
    return {
      slides: [
        {
          title: this.$t('featuresSlideContent.feature.dashboard-and-profile'),
          image: baseUrl + 'profile-and-dashboard.jpg'
        },
        {
          title: this.$t('featuresSlideContent.feature.public-competitions'),
          image: baseUrl + 'public-competitions.jpg'
        },
        {
          title: this.$t('featuresSlideContent.feature.positions-and-schedule'),
          image: baseUrl + 'positions-and-schedule.jpg'
        },
        {
          title: this.$t('featuresSlideContent.feature.create-competition'),
          image: baseUrl + 'create-competition.jpg'
        },
        {
          title: this.$t('featuresSlideContent.feature.coins-and-shop'),
          image: baseUrl + 'coins-and-shop.jpg'
        },
        {
          title: this.$t('featuresSlideContent.feature.friends-and-online-ids'),
          image: baseUrl + 'friends-and-online-id.jpg'
        },
        {
          title: this.$t('featuresSlideContent.feature.basic-and-premium'),
          image: baseUrl + 'basic-and-premium.jpg'
        },
      ]
    };
  }
};
</script>
<style scoped>
.featuresSlider >>> .vueperslides .vueperslide__title {
  color: white; /* var(--v-accent-base); */
}
.featuresSlider >>> .vueperslides__bullets,
.featuresSlider >>> .vueperslides__arrows {
  color: var(--v-secondary-base);
}

.featuresSlider >>> .vueperslides .vueperslide__content-wrapper {
  justify-content: flex-end;
}
</style>